import { useMutation } from "@tanstack/react-query";
import { postCreateHpr } from "apis";

const usePostCreateHpr = () => {
  return useMutation(postCreateHpr);
};

export default usePostCreateHpr;
